import React, { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatBRNumber } from '@utils/formatters';
import useSwr from '@hooks/useSwr';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import getPercentage from '@utils/percentage';
import StatCard from '@components/StatCard';
import { valueType } from 'antd/lib/statistic/utils';
import SessionContext from '@providers/Session/SessionContext';

interface IscaStatusProps {
  filters: {
    showContracted: 'true' | 'false';
  };
}

const IscaStatus = ({ filters }: IscaStatusProps) => {
  const { t } = useTranslation(['dashboard', 'inventory']);
  const navigate = useNavigate();
  const { selectedApp } = useContext(SessionContext);

  const { data } = useSwr(
    `/service-proxy/inventory/MOT/dashboards/expiring-baits?daysToExpire=15`,
    {
      method: 'post',
      data: {
        ...filters,
      },
    },
  );

  const onClick = useCallback(() => {
    const today = moment().format('YYYYMMDD');
    const in15days = moment().add(15, 'days').format('YYYYMMDD');

    navigate(
      `/${selectedApp}/mobile-network/assets/inventory?showContracted=${filters.showContracted}&isca=true&cancellationDateFrom=${today}&cancellationDateTo=${in15days}`,
    );
  }, [filters.showContracted, navigate, selectedApp]);

  const percentage = useMemo(
    () => (data ? `(${getPercentage(data?.matching, data?.total, 2)}%)` : 0),
    [data],
  );

  const formatStatisticValue = useCallback(
    (value: valueType) => formatBRNumber(value),
    [],
  );

  return (
    <StatCard
      loading={!data}
      noData={data?.length === 0 || data?.total === 0}
      onClick={onClick}
      precision={0}
      suffix={percentage}
      title={t('isca-expiring-in-days', {
        days: 15,
      })}
      value={data?.matching ?? 0}
      formatter={formatStatisticValue}
    />
  );
};

export default IscaStatus;
